export const catalog_matrix = [
  {form_key:'periodicity_id', catalog_key:'service_periodicities'},
  {form_key:'responsible_id', catalog_key:'none', propname:'users'},
]